import getPageName from "./getPageName";
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Pagination, Navigation]);

const revieews_career = () => {
  if (getPageName() != "careercenter") {
    return;
  }

  const reviewsWrapCareer1 = document.querySelector(
      ".reviews__cards-wrapper-block-1"
    ),
    reviewsWrapCareer2 = document.querySelector(
      ".reviews__cards-wrapper-block-2"
    );

  async function parseReviewsCareer() {
    let response = await fetch(`/files/reviews-career.json`),
      result = await response.json();

    result.forEach((el) => {
      createReviewsCardCareer(el);
    });
  }

  function createReviewsCardCareer(data) {
    let renderVideoCard = (item, i) => {
      return `<div class="reviews__card reviews__card-video swiper-slide">
            <div class="reviews__card-wrap reviews__card-wrap-video video-${item.modal}">
              <video class="reviews__card-videoFrame" loop="loop" muted="muted" preload="none" poster=${item.poster} src=${item.src} playsinline="" class="reviews-students__item-media">
              </video>
              <div class="cardBottom__right">
                  <a data-fslightbox="review-${i}" href="${item.video}" class="cardBottom__link"></a>
                  <p class="cardBottom__p">Смотреть отзыв</p>
            </div>
              <div class="reviews__card-bottom cardBottom">
                <p class="cardBottom__left">${item.name}</p>
              </div>
                </div>
            </div>`;
    };

    let renderTextCard = (item) => {
      return `<div class="reviews__card swiper-slide">
            <div class="reviews__card-wrap">
                <div class="reviews__card-block">
                    <div class="reviews__card-head">
                    <img src="${
                      item.img ? item.img : "/img/tgu/reviews/icon.svg"
                    }" loading="lazy" alt="">
                    <h4>${item.name}</h4>
                    </div>
                    <p class="reviews__card-text">${item.text}</p>
                </div>
                <div class="reviews__card-rating">
                    <p>${item.rating} / 5</p>
                    <div class="reviews__card-rating__icons ${item.star}"></div>
                </div>
            </div>
            </div>`;
    };

    if (data.id == 1) {
      data.data.forEach((item) => {
        if (item.video) {
          reviewsWrapCareer1.innerHTML += renderVideoCard(item);
        } else {
          reviewsWrapCareer1.innerHTML += renderTextCard(item);
        }
      });
    }

    if (data.id == 2) {
      data.data.forEach((item) => {
        if (item.video) {
          reviewsWrapCareer2.innerHTML += renderVideoCard(item);
        } else {
          reviewsWrapCareer2.innerHTML += renderTextCard(item);
        }
      });
    }

    setTimeout(() => {
      const slider_1 = document.querySelector(".reviewsCareer-block-1");
      const slider_2 = document.querySelector(".reviewsCareer-block-2");

      new Swiper(slider_1, {
        speed: 200,
        loop: true,
        breakpoints: {
          1281: {
            slidesPerView: 5,
            spaceBetween: 20,
            centeredSlides: true,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 10,
            centeredSlides: true,
          },
          751: {
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
          },
          665: {
            slidesPerView: 2,
            spaceBetween: 10,
            centeredSlides: true,
          },
          580: {
            slidesPerView: 1.7,
            spaceBetween: 10,
            centeredSlides: false,
          },
          530: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            centeredSlides: false,
          },
          480: {
            slidesPerView: 1.3,
            spaceBetween: 10,
            centeredSlides: false,
          },
          420: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            centeredSlides: false,
          },
          361: {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: false,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: true,
          },
        },
        navigation: {
          nextEl: ".reviews-swiper__next-block-1",
          prevEl: ".reviews-swiper__prev-block-1",
        },
        on: {
          init: function () {
            const totalSlides = this.slides.length;

            let i = 0;

            for (let item of this.slides) {
              item.classList.contains("swiper-slide-duplicate") ? i++ : "";
            }
            document.querySelector(
              ".reviews-pagination-total-block-1"
            ).innerHTML = totalSlides - i;
          },
          slideChange: function () {
            const index_currentSlide = this.realIndex + 1;
            document.querySelector(
              ".reviews-pagination-current-block-1"
            ).innerHTML = index_currentSlide;
          },
        },
      });

      new Swiper(slider_2, {
        speed: 200,
        loop: true,
        breakpoints: {
          1281: {
            slidesPerView: 5,
            spaceBetween: 20,
            centeredSlides: true,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 10,
            centeredSlides: true,
          },
          751: {
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
          },
          665: {
            slidesPerView: 2,
            spaceBetween: 10,
            centeredSlides: true,
          },
          580: {
            slidesPerView: 1.7,
            spaceBetween: 10,
            centeredSlides: false,
          },
          530: {
            slidesPerView: 1.5,
            spaceBetween: 10,
            centeredSlides: false,
          },         
          361: {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: false,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: true,
          },
        },
        navigation: {
          nextEl: ".reviews-swiper__next-block-2",
          prevEl: ".reviews-swiper__prev-block-2",
        },
        on: {
          init: function () {
            const totalSlides = this.slides.length;

            let i = 0;

            for (let item of this.slides) {
              item.classList.contains("swiper-slide-duplicate") ? i++ : "";
            }
            document.querySelector(
              ".reviews-pagination-total-block-2"
            ).innerHTML = totalSlides - i;
          },
          slideChange: function () {
            const index_currentSlide = this.realIndex + 1;
            document.querySelector(
              ".reviews-pagination-current-block-2"
            ).innerHTML = index_currentSlide;
          },
        },
      });

      refreshFsLightbox();
    }, 50);
  }

  parseReviewsCareer();
};

export default revieews_career;
